export enum DeliveryType {
  Standard = 'standard', // 일반 배송
  Shak = 'shak', // 샥 배송
  Today = 'today', // 오늘출발
  Reserved = 'reserved', // 예약판매
  Fast = 'fast', // 오늘출발 + 샥 배송
}
